import { Checkbox, CheckboxGroup } from '@availity/form';
import { FormGroup } from 'reactstrap';

const InputForm = ({ name, readOnly, checkboxStyle, children }) => {
  const disabledStyle = readOnly ? { cursor: 'not-allowed' } : {};
  return (
    <FormGroup>
      <CheckboxGroup name={name}>
        <Checkbox
          groupName={name}
          label={children}
          value="yes"
          disabled={readOnly}
          style={{ ...checkboxStyle, ...disabledStyle }}
        />
      </CheckboxGroup>
    </FormGroup>
  );
};

export default InputForm;
